import type { FaireProductEntity } from "../../entity_types/product";

export const p_7dcqpf7jgh: FaireProductEntity = {
  token: "p_7dcqpf7jgh",
  type: "product",
  name: "6 pc Pack Palosnato Aroma Scent Scented Candles Spiritual",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/84d5ef25423fe58177cce0b2f78a78c5bacf8841dbd6227207b531431e9e53b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ffe87a2dd5b1b732b3b8e8253eb1caa8fe59b6e51bd76367e2e37981b394c84.jpeg",
    "https://cdn.faire.com/fastly/cb4b13ed833fc8387e546fba91cae4256b47e1e607f73e2aa47d572840c60750.jpeg",
    "https://cdn.faire.com/fastly/85032ad5a8e7d1992b2aa457870f4ccee0ceb4a0ed5ea8356244687b3c4a7c74.jpeg",
    "https://cdn.faire.com/fastly/924c7712a02fd85216d75ccc536006257f3877e0cd5d24ea3e52f196be33d694.jpeg",
  ],
  priceDollars: 10.4,
  description:
    "Our Palo Santo Smudge is the perfect fit for you, whether you're a Palo Santo pro or a beginner. Our Palo Santo will leave your home surrounded with good vibes and a fresh smile air\nSome of our bundles are homegrown and harvested, which makes them super fresh and fragrant. Our large sage plants produce a good amount of sage, which we love to use to provide our customers with the best sage we can find.\n\nPalo Santo is used to leaving your home smelling fragrant and fresh and is also believed by many to have healing and spiritual benefits. It is said that burning palo santo in your home will bring prosperity and wisdom to your home and anyone in your household.\n\nOur Palo Santo sticks\nThey are each approximately 4\"\nHarvested strong lasting aroma scent incense scented candles spiritual",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:48.251Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
